export const getImageAlt = image =>
  (image.caption ?? Boolean(image.photographer))
    ? `Foto: ${image.photographer}`
    : '';

export const getTeaserMedia = (article, hideAuthorPortrait) => {
  if (!article) {
    return null;
  }

  if (
    !hideAuthorPortrait &&
    ['chronicle', 'editorial'].includes(article.type) &&
    article.authors[0]?.image2?.['image_id']
  ) {
    const [{ image2: image, firstname, lastname }] = article.authors;
    return {
      id: image.image_id,
      focus: image.focus_point,
      alt: `${firstname} ${lastname}`,
    };
  }
  if (article.teaser_image?.['cdn_id']) {
    const image = article.teaser_image;
    return {
      id: image.cdn_id,
      focus: image.focus_point,
      alt: getImageAlt(image),
    };
  }
  if (article.video?.['image_id']) {
    return {
      id: article.video.image_id,
      focus: null,
      alt: article.video.title,
    };
  }
  if (article.archive_images?.length) {
    const image = article.archive_images[0];
    return {
      id: image.cdn_id,
      focus: image.focus_point,
      alt: getImageAlt(image),
    };
  }

  return null;
};
